import { useEffect, useState } from "react";
import "./GlCoa.scss";
import { useSelector } from "react-redux";
import newRequest from "../../../utils/newRequest";
import { ScaleLoader } from "react-spinners";
import { IoClose, IoAdd, IoCloseSharp } from "react-icons/io5";
import { FiSearch } from "react-icons/fi";
import { motion } from "framer-motion";
import CircularButton, { CustomLoadingButton } from "../../../components/ui/CustomButton";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog";
import {
    DialogActions,
    Dialog,
    DialogTitle,
    DialogContent,
    Table,
    TableContainer,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    TablePagination,
} from "@mui/material";
import { customSelectStyles_dark, customSelectStyles_light } from "../../../components/ui/CustomSelect";
import { ToggleSwitch } from "../../../components/toogle/ToggleSwitch";
import Select from "react-select";
import { FaSave } from "react-icons/fa";
import { showToast } from "../../../toastService";
import { useTranslation } from "react-i18next";
import { MdAdd, MdClose } from "react-icons/md";

const GlCoa = () => {
    const { t } = useTranslation();
    const { currentTheme } = useSelector((state) => state.theme);
    const { currentUser } = useSelector((state) => state.user);
    const [isProcessing, setIsProcessing] = useState(false);
    const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
    const [confirmDialogAction, setConfirmDialogAction] = useState("None");
    const [confirmationActiontext, setConfirmationActiontext] = useState("");
    const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
    const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
    const [notifyDialogText, setNotifyDialogText] = useState("Text");
    const [isLoading, setIsLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const [searchTermSub, setSearchTermSub] = useState("");
    const [searchTermTree, setSearchTermTree] = useState("");
    const [currentAction, setCurrentAction] = useState(null);
    const [coaTree, setCoaTree] = useState([]);
    const [selectedCoaTreeLevel, setSelectedCoaTreeLevel] = useState(null);
    const [objectToAction, setObjectToAction] = useState({
        object_id: "",
        action_text: "",
        new_doc_status: "",
    });


    const fetchCoaTree = async (firstTime = false) => {
        try {
            if (firstTime) {
                setIsLoading(true);
            } else {
                setIsProcessing(true);
            }
            // Simulate delay for 5 seconds
            // await new Promise((resolve) => setTimeout(resolve, 5000));
            const res = await newRequest.get("/glCoaLevel/getCoaTree");
            setCoaTree(res.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            if (firstTime) {
                setIsLoading(false);
            } else {
                setIsProcessing(false);
            }
        }
    };

    const [newCode, setNewCode] = useState("");
    const [newText, setNewText] = useState("");
    const [isLedgerDialogOpen, setIsLedgerDialogOpen] = useState(false);
    const [mainLedgersRowsPerPage, setMainLedgersRowsPerPage] = useState(7);
    const [mainLedgersPage, setMainLedgersPage] = useState(0);
    const [selectedMainLedger, setSelectedMainLedger] = useState(null);
    const [mainLedgers, setMainLedgers] = useState([]);
    const fetchMainLedgers = async (coaLevelCode) => {
        try {
            setIsProcessing(true);
            setMainLedgers([]);
            const res = await newRequest.post("/glMainAccount/getCoaLevelMainAccount", { coa_level_code: coaLevelCode });
            setMainLedgers(res.data);

            if (res.data) {
                await fetchSubLedgers(res.data[0]?.ma_code);
                setSelectedMainLedger(res.data[0]);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setIsProcessing(false);
        }
    };
    const handleMainLedgersChangePage = (event, newPage) => {
        setMainLedgersPage(newPage);
    };
    const handleMainLedgersChangeRowsPerPage = (event) => {
        setMainLedgersRowsPerPage(parseInt(event.target.value, 7));
        setMainLedgersPage(0);
    };
    const slicedMainLedgersData = mainLedgers?.slice(
        mainLedgersPage * mainLedgersRowsPerPage,
        mainLedgersPage * mainLedgersRowsPerPage + mainLedgersRowsPerPage
    );

    const [subLedgersRowsPerPage, setSubLedgersRowsPerPage] = useState(5);
    const [subLedgersPage, setSubLedgersPage] = useState(0);
    const [selectedSubLedger, setSelectedSubLedger] = useState(null);
    const [subLedgers, setSubLedgers] = useState([]);
    const fetchSubLedgers = async (mainLedgerCode) => {
        try {
            setIsProcessing(true);
            setSubLedgers([]);
            const res = await newRequest.post("/glSubAccount/findAll", { sa_ma_code: mainLedgerCode });
            setSubLedgers(res.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setIsProcessing(false);
        }
    };
    const handleSubLedgersChangePage = (event, newPage) => {
        setSubLedgersPage(newPage);
    };
    const handleSubLedgersChangeRowsPerPage = (event) => {
        setSubLedgersRowsPerPage(parseInt(event.target.value, 10));
        setSubLedgersPage(0);
    };
    const slicedSubLedgersData = subLedgers?.slice(
        subLedgersPage * subLedgersRowsPerPage,
        subLedgersPage * subLedgersRowsPerPage + subLedgersRowsPerPage
    );

    const [subLedgerTypes, setSubLedgerTypes] = useState([]);
    const fetchSubLedgerTypes = async () => {
        try {
            const options = ["None", "Account", "Entity"].map((sc) => ({
                value: sc,
                label: sc,
            }));
            setSubLedgerTypes(options);
        } catch (error) {
            console.error("Error fetching entity types:", error);
        }
    };


    const handleMainLedgerChange = (value, rowId, field) => {
        setMainLedgers((prevMgl) =>
            prevMgl.map((item) =>
                item._id === rowId
                    ? { ...item, [field]: value, changed_xx: "Y" }
                    : item
            )
        );
    };

    const handleSubLedgerChange = (value, rowId, field) => {
        setSubLedgers((prevMgl) =>
            prevMgl.map((item) =>
                item._id === rowId
                    ? { ...item, [field]: value, changed_xx: "Y" }
                    : item
            )
        );
    };


    const handleConfirm = async () => {
        try {
            if (confirmDialogAction === "deleteReport") {

            } else if (confirmDialogAction === "deleteParameter") {

            }
        } catch (err) {
            console.log(err);
        }
        // Close the dialog
        setIsConfirmDialogOpen(false);
    };


    const renderTree = (nodes, level = 0) => {
        return (
            <div>
                {nodes
                    .filter(
                        (node) =>
                            node.lv_name.toLowerCase().includes(searchTermTree.toLowerCase()) ||
                            node.lv_code.toLowerCase().includes(searchTermTree.toLowerCase()) ||
                            node.children.some(child =>
                                child.lv_name.toLowerCase().includes(searchTermTree.toLowerCase()) ||
                                child.lv_code.toLowerCase().includes(searchTermTree.toLowerCase())
                            ) // Keeps parents if children match
                    )
                    .map((node) => (
                        <div
                            key={node._id}
                            className={`tree-branch ${!node.lv_parent_code ? "primary" : ""}`}
                            style={{ paddingLeft: node.lv_parent_code ? `${level * 15}px` : "0px" }}
                        >
                            <div
                                onClick={async () => {
                                    try {
                                        await fetchMainLedgers(node?.lv_code);
                                        setSelectedCoaTreeLevel(node);

                                    } catch (error) {
                                        console.log(error);
                                    }
                                }}
                                className={`${selectedCoaTreeLevel?._id === node._id ? "single-option active" : "single-option"}`}
                            >
                                <span>
                                    {node?.lv_parent_code ? `${node?.lv_code} - ${node?.lv_name}` : `${node?.lv_name}`}
                                </span>
                            </div>
                            {node?.children?.length > 0 && renderTree(node.children, level + 1)}
                        </div>
                    ))}
            </div>
        );
    };

    const filterTree = (nodes) =>
        nodes
            .map((node) => ({
                ...node,
                children: filterTree(node.children),
            }))
            .filter(
                (node) =>
                    node.lv_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    node.lv_code.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    node.children?.length > 0
            );

    useEffect(() => {
        fetchCoaTree(true);
        fetchSubLedgerTypes();
    }, []);

    const addNodeToTree = (nodes, newNode) => {
        return nodes.map(node => {
            if (node?.lv_code === newNode?.lv_parent_code) {
                // Found the parent, add the new node to its children
                return { ...node, children: [...node.children, newNode] };
            } else if (node.children?.length > 0) {
                // Recursively check child nodes
                return { ...node, children: addNodeToTree(node.children, newNode) };
            }
            return node;
        });
    };

    const saveRecord = async (e) => {
        try {
            setIsProcessing(true);
            // main ledgers
            const changedMainLedgers = mainLedgers?.filter((obj) => obj.changed_xx === "Y");

            for (let i = 0; i < changedMainLedgers?.length; i++) {
                const res = await newRequest.put(
                    `/glMainAccount/upd/${changedMainLedgers[i]._id}`,
                    {
                        ma_name: changedMainLedgers[i].ma_name,
                        ma_enabled: changedMainLedgers[i].ma_enabled,
                        ma_sub_type: changedMainLedgers[i].ma_sub_type
                    }
                );
            }

            setNotifyDialogTitle("Note!");
            setNotifyDialogText(`Changes Saved!`);
            setIsNotifyDialogOpen(true);
        } catch (error) {
            console.log(error);
        } finally {
            setIsProcessing(false);
        }
    };

    const handleAddLedger = async () => {
        try {

            if (!newCode) {
                setNotifyDialogTitle("Note!");
                setNotifyDialogText(`Please enter unique code!`);
                setIsNotifyDialogOpen(true);
                return;
            }

            if (!newText) {
                setNotifyDialogTitle("Note!");
                setNotifyDialogText(`Please enter name!`);
                setIsNotifyDialogOpen(true);
                return;
            }
            console.log(`objectToAction?.new_doc_status : ${objectToAction?.new_doc_status}`);
            setIsProcessing(true);
            if (objectToAction?.new_doc_status === "newCoaLevel") {
                const res = await newRequest.post("/glCoaLevel/add",
                    {
                        lv_coa_code: selectedCoaTreeLevel?.lv_coa_code,
                        lv_code: newCode,
                        lv_name: newText,
                        lv_category: selectedCoaTreeLevel?.lv_category,
                        lv_parent_code: selectedCoaTreeLevel?.lv_code,
                    });

                if (res.data.msg === "added") {
                    setCoaTree(prevTree => {
                        const updatedTree = addNodeToTree(prevTree, res.data.coa);
                        return [...updatedTree]
                    });
                    // Set the newly added node as the selected one
                    setSelectedCoaTreeLevel(res.data.coa);
                    await fetchMainLedgers(res.data.coa?.lv_code);
                    setIsLedgerDialogOpen(false);
                    setIsProcessing(false);
                    setNewCode("");
                    setNewText("");
                    showToast(`Added`, "success");
                } else if (res.data.msg === "exists") {
                    showToast(`Ledger code ${newCode} already exists`, "error");
                } else {
                    showToast(`Unable to add ledger`, "error");
                }
            } else if (objectToAction?.new_doc_status === "newMainLedger") {
                const res = await newRequest.post("/glMainAccount/add",
                    {
                        ma_code: newCode,
                        ma_name: newText,
                        ma_coa_code: selectedCoaTreeLevel?.lv_coa_code,
                        ma_lv_code: selectedCoaTreeLevel?.lv_code,
                    });

                if (res.data.msg === "added") {
                    setMainLedgers((prev) => [...prev, res.data.ledger]);
                    setIsLedgerDialogOpen(false);
                    setIsProcessing(false);
                    setNewCode("");
                    setNewText("");
                    showToast(`Added`, "success");
                } else if (res.data.msg === "exists") {
                    showToast(`Ledger code ${newCode} already exists`, "error");
                } else {
                    showToast(`Unable to add ledger`, "error");
                }
            } else if (objectToAction?.new_doc_status === "newSubLedger") {
                const res = await newRequest.post("/glSubAccount/add",
                    {
                        sa_code: newCode,
                        sa_name: newText,
                        sa_ma_code: selectedMainLedger?.ma_code,
                    });

                if (res.data.msg === "added") {
                    setSubLedgers((prev) => [...prev, res.data.ledger]);
                    setIsLedgerDialogOpen(false);
                    setIsProcessing(false);
                    setNewCode("");
                    setNewText("");
                    showToast(`Added`, "success");
                } else if (res.data.msg === "exists") {
                    showToast(`Ledger code ${newCode} already exists`, "error");
                } else {
                    showToast(`Unable to add ledger`, "error");
                }
            }
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <div className='gl-coa'>
            {isLoading ? (
                <div className="no-content">
                    <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
                </div>
            ) : (
                <motion.div
                    className="gl-coa-main-wrapper"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}>
                    <div className="gl-coa-center-wrapper">
                        <div className="center-navbar">
                            <div className="navbar-left">
                                <h1 className="page-title">{selectedCoaTreeLevel?.lv_name?.toUpperCase()}</h1>
                                <h1 className="sub-title soft" style={{ fontSize: "12px" }}>{selectedCoaTreeLevel?.lv_code}</h1>
                            </div>
                            <div className="navbar-right">
                                <CustomLoadingButton
                                    currentTheme={currentTheme}
                                    iconPosition="end"
                                    borderRadiusType="both"
                                    variant="tint"
                                    color="#00D37F"
                                    tooltip="Save changes"
                                    endIcon={<FaSave />}
                                    onClick={saveRecord}>
                                    {t('save')}
                                </CustomLoadingButton>
                                {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                                    <CustomLoadingButton
                                        currentTheme={currentTheme}
                                        iconPosition="end"
                                        borderRadiusType="both"
                                        variant="tint"
                                        color="#0ea5a4"
                                        tooltip={`Add ledger to [${selectedCoaTreeLevel?.lv_name} : ${selectedCoaTreeLevel?.lv_code}]`}
                                        endIcon={<IoAdd />}
                                        onClick={() => {
                                            try {
                                                setObjectToAction({
                                                    object_id: "",
                                                    action_text: "",
                                                    new_doc_status: "newMainLedger",
                                                });
                                                setIsLedgerDialogOpen(true);
                                            } catch (error) {
                                                console.log(error);
                                            }
                                        }}
                                    >
                                        {t('addLedger')}
                                    </CustomLoadingButton>}
                                {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                                    <CustomLoadingButton
                                        currentTheme={currentTheme}
                                        iconPosition="end"
                                        borderRadiusType="both"
                                        variant="tint"
                                        color="#0ea5a4"
                                        tooltip={t('addLevel')}
                                        endIcon={<MdAdd />}
                                        onClick={() => {
                                            try {

                                                if (!selectedCoaTreeLevel) {
                                                    setNotifyDialogTitle("Note!");
                                                    setNotifyDialogText(`Please select level to add under!`);
                                                    setIsNotifyDialogOpen(true);
                                                    return;
                                                }

                                                if (mainLedgers?.length > 0) {
                                                    setNotifyDialogTitle("Note!");
                                                    setNotifyDialogText(`You CANNOT add another level to this level because Ledgers already defined!`);
                                                    setIsNotifyDialogOpen(true);
                                                    return;
                                                }

                                                setObjectToAction({
                                                    object_id: "",
                                                    action_text: "",
                                                    new_doc_status: "newCoaLevel",
                                                });
                                                setIsLedgerDialogOpen(true);
                                            } catch (error) {
                                                console.log(error);
                                            }
                                        }}
                                    >
                                        {t('addLevel')}
                                    </CustomLoadingButton>}
                            </div>
                        </div>
                        <div className="center-content">
                            <div className="center-content-navbar">
                                <div className="center-content-left">
                                    {mainLedgers?.length > mainLedgersRowsPerPage &&
                                        <div className="homeSearch" style={{ width: "100%" }}>
                                            <FiSearch className="homeSearchIcon" />
                                            <input
                                                className="homeSearchInput"
                                                type="text"
                                                placeholder={t('search')}
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}

                                            />
                                            {searchTerm?.length > 0 ? (
                                                <MdClose
                                                    className="homeSearchClear"
                                                    onClick={() => setSearchTerm("")}
                                                />
                                            ) : (
                                                <span className="homeSearchClearPlaceholder" />
                                            )}
                                        </div>}
                                </div>
                                <div className="center-content-right">
                                    {mainLedgers?.length > mainLedgersRowsPerPage &&
                                        <TablePagination
                                            rowsPerPageOptions={[7]}
                                            rowsPerPage={mainLedgersRowsPerPage}
                                            onRowsPerPageChange={handleMainLedgersChangeRowsPerPage}
                                            component="div"
                                            count={mainLedgers?.length}
                                            page={mainLedgersPage}
                                            onPageChange={handleMainLedgersChangePage}
                                        />}
                                </div>
                            </div>
                            <div className="table-content">
                                <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                                    <Table sx={{ width: "max-content", border: 'none' }}>
                                        <TableHead className="tablehead">
                                            <TableRow className="tablerow">
                                                <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                                    #
                                                </TableCell>
                                                <TableCell className="table-cell left" style={{ maxWidth: "100px" }}>
                                                    <span>{t('code').toUpperCase()}</span>
                                                </TableCell>
                                                <TableCell className="table-cell left" style={{ width: "auto" }}>
                                                    <span>{t('name').toUpperCase()}</span>
                                                </TableCell>
                                                <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                                    <span>{t('category').toUpperCase()}</span>
                                                </TableCell>
                                                <TableCell className="table-cell left" style={{ maxWidth: "150px" }}>
                                                    <span>{t('subs').toUpperCase()}</span>
                                                </TableCell>
                                                <TableCell className="table-cell left" style={{ maxWidth: "100px" }}>
                                                    <span>{t('enabled').toUpperCase()}</span>
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody className="tablebody">
                                            {slicedMainLedgersData
                                                ?.filter(
                                                    (row) =>
                                                        row?.ma_code.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                                        row?.ma_name.toLowerCase().includes(searchTerm.toLowerCase())
                                                )
                                                .map((row, index) => (
                                                    <TableRow
                                                        key={row?._id}
                                                        className={`${selectedMainLedger?._id === row._id ? "tablerow current" : "tablerow"}`}
                                                        onClick={async () => {
                                                            try {
                                                                await fetchSubLedgers(row?.ma_code);
                                                                setSelectedMainLedger(row);
                                                            } catch (error) {
                                                                console.log(error);
                                                            }
                                                        }}
                                                    >
                                                        <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                                            <h1 className="normal-title">{mainLedgersPage * mainLedgersRowsPerPage + index + 1}</h1>
                                                        </TableCell>
                                                        <TableCell className="table-cell left" style={{ maxWidth: "100px" }}>
                                                            <h1 className="sub-title">{row?.ma_code}</h1>
                                                        </TableCell>
                                                        <TableCell className="table-cell left" style={{ width: "auto" }}>
                                                            <h1 className="sub-title">{row?.ma_name}</h1>
                                                        </TableCell>
                                                        <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                                            <h1 className="sub-title">{row?.ma_category}</h1>
                                                        </TableCell>
                                                        <TableCell className="table-cell left" style={{ maxWidth: "150px" }}>
                                                            <Select
                                                                id="ma_sub_type"
                                                                name="ma_sub_type"
                                                                menuPortalTarget={document.body}
                                                                styles={{
                                                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                    menuPortal: base => ({
                                                                        ...base,
                                                                        zIndex: 9999,
                                                                    })
                                                                }}
                                                                width="140px"
                                                                height="32px"
                                                                value={subLedgerTypes.find((option) => option.value === row?.ma_sub_type) || null}
                                                                onChange={(selectedOption) => handleMainLedgerChange(selectedOption?.value, row._id, "ma_sub_type")}
                                                                options={subLedgerTypes}
                                                                placeholder={t('type')}
                                                            />
                                                        </TableCell>
                                                        <TableCell className="table-cell left" style={{ maxWidth: "100px" }}>
                                                            <ToggleSwitch
                                                                id={row._id}
                                                                value={row.ma_enabled}
                                                                onChange={(newValue) => handleMainLedgerChange(newValue, row._id, "ma_enabled")}
                                                                label=""
                                                                labelPosition="end"
                                                                labelWidth="max-content"
                                                                border="N"
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </div>

                        {/* sub ledgers */}
                        {mainLedgers?.length > 0 &&
                            selectedMainLedger?.ma_sub_type === "Account" && <hr className="separator-h" />}
                        {/* THIS VIEW SHOWS IF SELECTED MAIN LEDGER ALLOWS ACCOUNT AS SUB LEDGERS */}
                        {mainLedgers?.length > 0 &&
                            selectedMainLedger?.ma_sub_type === "Account" &&
                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%", margin: "10px 0px", gap: "10px" }}>
                                <span>{t('addSubLedgers', { param1: selectedMainLedger?.ma_name, param2: selectedMainLedger?.ma_code }).toUpperCase()}</span>
                                <CircularButton currentTheme={currentTheme}
                                    onClick={async () => {
                                        if (!selectedMainLedger) {
                                            setNotifyDialogTitle("Note!");
                                            setNotifyDialogText(`Please select main ledger!`);
                                            setIsNotifyDialogOpen(true);
                                            return;
                                        }

                                        setObjectToAction({
                                            object_id: "",
                                            action_text: "",
                                            new_doc_status: "newSubLedger",
                                        });
                                        setIsLedgerDialogOpen(true);

                                    }} icon={<MdAdd />} width={"35px"} height={"35px"} />
                            </div>}
                        {/* THIS VIEW SHOWS IF SELECTED MAIN LEDGER ALLOWS ENTITIES AS SUB LEDGERS */}
                        {mainLedgers?.length > 0 &&
                            selectedMainLedger?.ma_sub_type === "Entity" &&
                            <div className="center-content">
                                <div className="entity-card">
                                    <span>{t('entitySubLedgers', { param1: selectedMainLedger?.ma_name, param2: selectedMainLedger?.ma_code }).toUpperCase()}</span>
                                </div>
                            </div>}
                        {/* THIS VIEW SHOWS IF SELECTED MAIN LEDGER ALLOWS ACCOUNT AS SUB LEDGERS */}
                        {mainLedgers?.length > 0 &&
                            selectedMainLedger?.ma_sub_type === "Account" &&
                            <div className="center-content">
                                <div className="center-content-navbar">
                                    <div className="center-content-left">
                                        {subLedgers.length > subLedgersRowsPerPage &&
                                            <div className="homeSearch" style={{ width: "100%" }}>
                                                <FiSearch className="homeSearchIcon" />
                                                <input
                                                    className="homeSearchInput"
                                                    type="text"
                                                    placeholder={t('search')}
                                                    value={searchTermSub}
                                                    onChange={(e) => setSearchTermSub(e.target.value)}

                                                />
                                                {searchTermSub?.length > 0 ? (
                                                    <MdClose
                                                        className="homeSearchClear"
                                                        onClick={() => setSearchTermSub("")}
                                                    />
                                                ) : (
                                                    <span className="homeSearchClearPlaceholder" />
                                                )}
                                            </div>
                                        }
                                    </div>
                                    <div className="center-content-right">
                                        {subLedgers.length > subLedgersRowsPerPage &&
                                            <TablePagination
                                                rowsPerPageOptions={[10]}
                                                rowsPerPage={subLedgersRowsPerPage}
                                                onRowsPerPageChange={handleSubLedgersChangeRowsPerPage}
                                                component="div"
                                                count={subLedgers.length}
                                                page={subLedgersPage}
                                                onPageChange={handleSubLedgersChangePage}
                                            />}
                                    </div>
                                </div>
                                <div className="table-content">
                                    <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                                        <Table sx={{ width: "max-content", border: 'none' }}>
                                            <TableHead className="tablehead">
                                                <TableRow className="tablerow">
                                                    <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                                        #
                                                    </TableCell>
                                                    <TableCell className="table-cell left" style={{ maxWidth: "150px" }}>
                                                        <span>CODE</span>
                                                    </TableCell>
                                                    <TableCell className="table-cell left" style={{ width: "auto" }}>
                                                        <span>NAME</span>
                                                    </TableCell>
                                                    <TableCell className="table-cell left" style={{ maxWidth: "100px" }}>
                                                        <span>ENABLED</span>
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody className="tablebody">
                                                {slicedSubLedgersData
                                                    ?.filter(
                                                        (row) =>
                                                            row?.sa_code.toLowerCase().includes(searchTermSub.toLowerCase()) ||
                                                            row?.sa_name.toLowerCase().includes(searchTermSub.toLowerCase())
                                                    )
                                                    .map((row, index) => (
                                                        <TableRow
                                                            key={row?._id}
                                                            className={`${selectedSubLedger?._id === row._id ? "tablerow current" : "tablerow"}`}
                                                            onClick={() => setSelectedSubLedger(row)}
                                                        >
                                                            <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                                                <h1 className="normal-title">{subLedgersPage * subLedgersRowsPerPage + index + 1}</h1>
                                                            </TableCell>
                                                            <TableCell className="table-cell left" style={{ maxWidth: "150px" }}>
                                                                <h1 className="sub-title">{row?.sa_code}</h1>
                                                            </TableCell>
                                                            <TableCell className="table-cell left" style={{ width: "auto" }}>
                                                                <h1 className="sub-title">{row?.sa_name}</h1>
                                                            </TableCell>
                                                            <TableCell className="table-cell left" style={{ maxWidth: "100px" }}>
                                                                <ToggleSwitch
                                                                    id={row._id}
                                                                    value={row.sa_enabled}
                                                                    onChange={(newValue) => handleSubLedgerChange(newValue, row._id, "sa_enabled")}
                                                                    label=""
                                                                    labelPosition="end"
                                                                    labelWidth="max-content"
                                                                    border="N"
                                                                />
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                            </TableBody>
                                        </Table>

                                    </TableContainer>
                                </div>
                            </div>}
                        {/* end of subleders */}
                    </div>
                    <div className="gl-coa-right-wrapper">
                        <div className="homeSearch">
                            <FiSearch className="homeSearchIcon" />
                            <input
                                className="homeSearchInput"
                                type="text"
                                placeholder={t('search')}
                                value={searchTermTree}
                                onChange={(e) => setSearchTermTree(e.target.value)}
                            />
                            {searchTermTree?.length > 0 ? (
                                <MdClose
                                    className="homeSearchClear"
                                    onClick={async () => setSearchTermTree("")}
                                />
                            ) : (
                                <span className="homeSearchClearPlaceholder" />
                            )}
                        </div>
                        <div className="options-list">
                            {coaTree.length ? renderTree(coaTree) : <h2 className="sub-title">none found</h2>}
                        </div>
                    </div>
                </motion.div>
            )}
            {isLedgerDialogOpen && (
                <motion.div
                    className="overlay-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="overlay-wrapper">
                        <div className="overlay-navbar">
                            <h1 className="main-title">
                                {objectToAction?.new_doc_status === "newMainLedger"
                                    ? "Add Ledger"
                                    : objectToAction?.new_doc_status === "newSubLedger"
                                        ? `Add Sub [${selectedMainLedger?.ma_code} - ${selectedMainLedger?.ma_name}]`
                                        : objectToAction?.new_doc_status === "newCoaLevel"
                                            ? "Add Level"
                                            : "Add"}
                            </h1>
                            <CircularButton
                                currentTheme={currentTheme}
                                onClick={() => {
                                    try {
                                        setIsLedgerDialogOpen(false);
                                    } catch (error) {
                                        console.log(error)
                                    }
                                }} icon={<IoClose />} width={"35px"} height={"35px"} />
                        </div>
                        <div className="overlay-content">
                            <div className="input-item-with-label">
                                <label
                                    htmlFor="dedcode"
                                    style={{
                                        width: "100px",
                                    }}
                                >
                                    CODE
                                </label>
                                <input
                                    id="dedcode"
                                    name="dedcode"
                                    type="text"
                                    placeholder="CODE"
                                    value={newCode}
                                    className="form-input-item"
                                    style={{ width: "400px" }}
                                    onChange={(e) => setNewCode(e.target.value)}
                                />
                            </div>
                            <div className="input-item-with-label">
                                <label
                                    htmlFor="dedtext"
                                    style={{
                                        width: "100px",
                                    }}
                                >
                                    NAME
                                </label>
                                <input
                                    id="dedtext"
                                    name="dedtext"
                                    type="text"
                                    placeholder="NAME"
                                    value={newText}
                                    className="form-input-item"
                                    style={{ width: "400px" }}
                                    onChange={(e) => setNewText(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="overlay-actions">
                            <CustomLoadingButton
                                currentTheme={currentTheme}
                                iconPosition="end"
                                endIcon={<IoAdd />}
                                onClick={handleAddLedger}
                            >
                                {t('add')}
                            </CustomLoadingButton>
                        </div>
                    </div>
                </motion.div>
            )}
            {/* Dialog to notify user about changes being saved */}
            <Dialog open={isNotifyDialogOpen}
                onClose={() => setIsNotifyDialogOpen(false)}
                PaperProps={{
                    sx: {
                        backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
                        color: currentTheme === "dark" ? "#fff" : "#000",
                    },
                }}
                slotProps={{
                    backdrop: {
                        sx: {
                            backgroundColor: "rgba(0, 0, 0, 0.7)",
                        },
                    },
                }}>
                <DialogTitle>{notifyDialogTitle}</DialogTitle>
                <DialogContent>
                    <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
                </DialogContent>
                <DialogActions>
                    <CustomLoadingButton onClick={() => setIsNotifyDialogOpen(false)}>Close</CustomLoadingButton>
                </DialogActions>
            </Dialog>
            {/* Confirm Dialog */}
            <ConfirmDialog
                isOpen={isConfirmDialogOpen}
                onClose={() => setIsConfirmDialogOpen(false)}
                onConfirm={handleConfirm}
                dialogTitle="Confirmation"
                dialogContent={<p dangerouslySetInnerHTML={{ __html: confirmationActiontext }} />}
            />
        </div>
    )
}



export default GlCoa;